module.exports = "/images/back.svg?184b4064752ac828ef89084a358c739a";